export default function () {
  if (document.getElementById('space-contact-app')) {
    import(/* webpackChunkName: "space-contact" */ '@organisms/page-space/contact/main');
  }
}
